import React, { memo, useCallback, useEffect, useRef, useState } from 'react';

import { addClass, removeClass } from '../../../utils/utils';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';

import { determineBatchShow } from '../../../actions/wallpaper';
import styles from './BatchAdd.module.less';
import config from '../config';
import Toast from '../../../components/Toast/Toast';
import { logging, logPostInfo } from '../../../actions/log';
import BatchAddImg from '../../../static/wp/wp_batch_add.svg';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';
import { handleLogin } from '../../../utils/hooks/useLoginStatus';
import { updateShowWpOrder } from '../../../actions/wallpaper';
import { PCStoreJsBridge } from '../../../nativeapi';

const SelectWpBatchInfoShow = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpBatchInfoShow,
);

const SelectWpBatchAddShow = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpBatchAddShow,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const SelectVipState = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.vipState,
);

export default memo(({ scollNode, text, submitJson = {}, source, loginTag }) => {
  const dispatch = useDispatch();
  const wpBatchInfoShow = useSelector(SelectWpBatchInfoShow);
  const [isHover, setIsHover] = useState(wpBatchInfoShow);
  const addImgNode = useRef(null);
  const addInfoNode = useRef(null);
  const addText = useRef(null);
  const textNode = useRef(null);
  const submitLog = useRef(null);
  const batchAddAllRef = useRef(null);
  const logInfoData = useSelector(selectLogInfo);
  const loginStatus = useLoginStatus();
  const vipState = useSelector(SelectVipState);
  const batchAddShow = useSelector(SelectWpBatchAddShow);

  useEffect(() => {
    // 因为当时发现进入我的的时候会读缓存 所以分类也的展现打桩在这里打  曾用 收藏 在页面打
    if (text?.page === 'category') {
      submitLog.current();
    }
  }, [text]);

  useEffect(() => {
    scollNode && scollNode.addEventListener('scroll', showOut, false);

    return () => {
      scollNode && scollNode.removeEventListener('scroll', showOut, false);
    };
  }, [scollNode]);

  useEffect(() => {
    removeClass(addImgNode.current, styles.batch_add_img_default);
    removeClass(addInfoNode.current, styles.batch_add_box_move_out);
    removeClass(addInfoNode.current, styles.batch_add_box_move_in);
    removeClass(addImgNode.current, styles.batch_add_img_move_out);
    removeClass(addImgNode.current, styles.batch_add_img_move_in);
    removeClass(textNode.current, styles.batch_add_text_move_out);
  }, []);

  useEffect(() => {
    if (wpBatchInfoShow) {
      removeClass(addImgNode.current, styles.batch_add_img_default);
      showIn();
    } else {
      // 因为会需求是根据打开商店后有没有进入过分类也来判断展现 所以这里收起的判断会变多
      if (
        ~~sessionStorage.getItem('FIRST_WP_CATEGORY') > 1 &&
        sessionStorage.getItem('FIRST_WP_CATEGORY') !== null &&
        text.page === 'category'
      ) {
        let aList = JSON.parse(JSON.stringify(addInfoNode.current.className.split(' '))) ?? [];

        let aIndex = 0;
        aList.forEach(e => {
          if (e.indexOf('batch_add_box_move_in') > -1) {
            aIndex++;
          }
        });
        if (aIndex > 0) {
          showOut();
        } else {
          setTimeout(() => {
            addClass(addImgNode.current, styles.batch_add_img_default);
          }, 400);
        }
      } else {
        showOut();
      }
    }
  }, [wpBatchInfoShow, text]);

  submitLog.current = () => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'I_Wallpaper_Resiguid',
        label: '',
        param2: {
          type: wpBatchInfoShow ? 'spread' : 'fewer',
          source: source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  };

  const showIn = () => {
    removeClass(batchAddAllRef.current, styles.batch_add_all_out);
    removeClass(batchAddAllRef.current, styles.batch_add_all_out);
    addClass(batchAddAllRef.current, styles.batch_add_all_in);
    removeClass(addImgNode.current, styles.batch_add_img_default);
    removeClass(addInfoNode.current, styles.batch_add_box_move_out);
    addClass(addInfoNode.current, styles.batch_add_box_move_in);
    removeClass(addImgNode.current, styles.batch_add_img_move_out);
    addClass(addImgNode.current, styles.batch_add_img_move_in);
    removeClass(textNode.current, styles.batch_add_text_move_out);
  };

  const callbackOrder = useCallback(
    flag => {
      if (flag) {
        handleAdd();
      }
    },
    [vipState],
  );

  const showOut = () => {
    removeClass(batchAddAllRef.current, styles.batch_add_all_in);
    addClass(batchAddAllRef.current, styles.batch_add_all_out);

    removeClass(addImgNode.current, styles.batch_add_img_default);
    removeClass(addInfoNode.current, styles.batch_add_box_move_in);
    addClass(addInfoNode.current, styles.batch_add_box_move_out);
    removeClass(addImgNode.current, styles.batch_add_img_move_in);
    addClass(addImgNode.current, styles.batch_add_img_move_out);
    addClass(textNode.current, styles.batch_add_text_move_out);
  };

  const handleAdd = useCallback(async () => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Resiguid',
        label: '',
        param2: {
          source: source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    if (loginStatus) {
      let res = await config.batchAdd(submitJson);
      if (res === false) {
        Toast.error({ content: '添加失败' });
      } else {
        if (res.status === 0) {
          let switchTurn = {};
          Toast.success({ content: '添加成功' });
          dispatch(
            determineBatchShow({
              ...submitJson,
              isShow: false,
            }),
          );
          dispatch(
            logging({
              category: 'Wallpaper',
              action: 'R_Wallpaper_Resiguid_Result',
              label: '',
              param2: {
                source: source,
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
              },
            }),
          );
          if (window?.external?.get_wallpaper_carousel_switch_info) {
            switchTurn = JSON.parse(window.external.get_wallpaper_carousel_switch_info() || '{}');
          }
          // 去开启轮播
          PCStoreJsBridge.switchWpOpenTurn({
            switch: 'on',
            duration: switchTurn?.duration || 5,
          });
        } else if (res.status === 2) {
          dispatch(
            updateShowWpOrder({
              show: true,
              wallpaperId: '',
              code: '',
              wpType: 3, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
              scenetype: 'resident', // 'set', 'dl', 'resident','resident_category', 'loop_single', 'loop_batch', 'loop_start'
              callbackTurnOrder: callbackOrder,
            }),
          );
        } else {
          Toast.error({ content: res.message });
        }
      }
    } else {
      handleLogin();
      loginTag();
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'P_Wallpaper_Resiguid_Login',
          label: '',
          param2: {
            source: source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  }, [submitJson, loginStatus, vipState]);

  return (
    <div className={styles.batch_add} onMouseLeave={() => showOut()} ref={batchAddAllRef}>
      {/* {!isHover && ( */}
      <div
        className={styles.batch_add_img}
        onMouseEnter={() => (
          showIn(),
          dispatch(
            logging({
              category: 'Wallpaper',
              action: 'I_Wallpaper_Resiguid_Hover',
              label: '',
              param2: {
                type: isHover ? 'spread' : 'fewer',
                source: source,
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
              },
            }),
          )
        )}
        ref={addImgNode}
      >
        <img src={BatchAddImg} />
      </div>
      {/* )} */}

      {/* {isHover && ( */}
      <div className={styles.batch_add_box} ref={addInfoNode}>
        <div className={styles.batch_add_info} ref={addText}>
          <div className={`info_text`} ref={textNode}>
            {submitJson.groupType === 2 ? (
              <>
                对 “<span className="info_text_importent">{text.info}</span>”
                壁纸感兴趣？一键加入轮播
              </>
            ) : (
              <>将{text.info}加入轮播列表</>
            )}{' '}
          </div>
          <div className="info_btn" onClick={handleAdd}>
            添加
          </div>
        </div>
      </div>
      {/* )} */}
    </div>
  );
});
